import axiosNeuron from "api/axios";
import endpoints from "api/endpoints";

interface IChannelListResultResponse {
  id: number;
  device: number;
  state: number;
  sensorType: number;
  placement: number;
  number: number;
  note: string;
}

interface IChannelListResponse {
  results: IChannelListResultResponse[];
}

export default async function getChannels(deviceSerialUid: string) {
  const url = `${endpoints.devices.getChannelsBySerialUid(
    deviceSerialUid
  )}?order_by=number`;
  try {
    const response = await axiosNeuron.get(url);
    const data: IChannelListResponse = {
      results: response.data.map((item: any) => ({
        id: item.id,
        device: item.device,
        state: item.state,
        sensorType: item.sensorType,
        placement: item.placement,
        number: item.number,
        note: item.note,
        type: item.type,
      })),
    };
    return data;
  } catch (error) {
    if (error !== undefined) {
      throw error;
    }
  }
}
